import { Route, Switch } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { PlanDetails } from "@/react/components/SettingsApp/Plan/PlanDetails/PlanDetails";
import { SettingsHeader } from "@/react/components/SettingsApp/SettingsHeader";
import {
  communityBillingPath,
  planSettingsPath,
} from "@/react/helpers/urlHelpers";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { PlansProvider } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { usePunditUserContext } from "@circle-react/contexts";
import { Loader } from "@circle-react-shared/uikit/Loader";
import { SettingsContainer } from "../../SettingsContainer";
import { useCurrentPlanApi } from "../hooks/useCurrentPlanApi";
import { NewPlansPageHeader } from "./NewPlansPageHeader";
import { PlansPageVariantA } from "./PlansPageVariantA";
import { PlansPageVariantB } from "./PlansPageVariantB";
import { PlansTabs } from "./PlansTabs";

interface PlanSettingsProps {
  isExpired: boolean;
}

const localeRoot = "pricing_plans.plan_settings";

export const PlanSettings = ({ isExpired }: PlanSettingsProps) => {
  const { currentCommunity } = usePunditUserContext();
  const { currentPlan } = useCurrentPlanApi();
  const { isCommunityOnTrial } = usePlanStatus();
  const { isVariantAEnabled, isVariantBEnabled } = usePlanPageVariant();

  if (!currentCommunity) {
    return <Loader />;
  }

  const subscription = currentCommunity?.subscription;
  const isSubscriptionCancelled = currentCommunity?.subscription_cancelled;

  const shouldSeeBillingTab = subscription && !isSubscriptionCancelled;

  const settingsContnet = (
    <SettingsContainer className="!bg-primary" maxWidth="none">
      <div className="min-h-screen w-full">
        <div className="mx-auto max-w-[960px]">
          <Switch>
            <Route path={planSettingsPath()}>
              <PlansProvider>
                {isVariantAEnabled && <PlansPageVariantA />}
                {isVariantBEnabled && <PlansPageVariantB />}
              </PlansProvider>
            </Route>
            <Route path={communityBillingPath()}>
              <PlanDetails
                showBillingPortal
                showAddons={currentPlan?.allow_addons}
              />
            </Route>
          </Switch>
        </div>
      </div>
    </SettingsContainer>
  );

  if (isCommunityOnTrial) {
    return (
      <NewPlansPageHeader
        pageTitle={t(`${localeRoot}.title`)}
        layoutConfigProps={{
          key: isExpired,
          disableSidebar: isExpired,
          shouldHideSidebarNestedNavBar: true,
        }}
      >
        {settingsContnet}
      </NewPlansPageHeader>
    );
  }

  return (
    <SettingsHeader
      pageTitle={t(`${localeRoot}.title`)}
      layoutConfigProps={{
        key: isExpired,
        disableSidebar: isExpired,
        shouldHideSidebarNestedNavBar: true,
      }}
      hasBorder={!shouldSeeBillingTab}
      filters={shouldSeeBillingTab && <PlansTabs />}
    >
      {settingsContnet}
    </SettingsHeader>
  );
};

export default PlanSettings;
